
import moment from 'moment'

import history from '../../containers/History'
import { getDataSource, getMe, getPrescriptions, getPhysiciansAndEkgStackCount, getPatients, getInterpretations, getOverview, getActivity } from '../../store/appReducer'
import { ROUTES, DATASOURCES, ALL_PHYSICIANS_OPTION, CLEAR_STATE } from '../../constants'

import {
  checkIdtfServiceProviderFeatureEnabled,
} from 'configs'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'Dashboard.'
export const RESET_FILTERS = `${PREFIX}RESET_FILTERS`
export const UPDATE_SELECTED_PHYSICIAN_ID = `${PREFIX}UPDATE_SELECTED_PHYSICIAN_ID`
export const DATA_REQUEST = `${PREFIX}DATA_REQUEST`
export const DATA_SUCCESS = `${PREFIX}DATA_SUCCESS`
export const DATA_FAILURE = `${PREFIX}DATA_FAILURE`

// ------------------------------------
// Actions
// ------------------------------------
export const updateSelectedPhysicianId = id => ({
  type: UPDATE_SELECTED_PHYSICIAN_ID,
  payload: id,
})
export const resetFilters = () => ({
  type: RESET_FILTERS,
})
export const dataRequest = () => ({
  type: DATA_REQUEST,
})
export const dataSuccess = () => ({
  type: DATA_SUCCESS,
})
export const dataFailure = () => ({
  type: DATA_FAILURE,
})


export const getDashboardData = (forceUpdate = false) => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const isIdtfServiceProviderFeatureEnabled = checkIdtfServiceProviderFeatureEnabled(meDataSource)
  if ((meDataSource && !meDataSource.isFetching) && isIdtfServiceProviderFeatureEnabled) {
    return history.push(ROUTES.CCT_WORK_LIST)
  }

  dispatch(dataRequest())

  let promises

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  return promises
    .then(() => {
      const apiCalls = []

      const {
        selectedStartDate,
        selectedEndDate,
      } = getState().dashboard
      const me = getDataSource(getState(), DATASOURCES.ME)
      const physicians = getDataSource(getState(), DATASOURCES.PHYSICIANS)
      const ekgStackCounts = getDataSource(getState(), DATASOURCES.EKG_STACK_COUNTS)

      const {
        teams,
      } = me.data

      apiCalls.push(dispatch(getOverview(teams[0].id)))
      apiCalls.push(dispatch(getActivity(teams[0].id, selectedStartDate.toISOString(), selectedEndDate.toISOString())))

      if (!physicians.data || !ekgStackCounts.data || forceUpdate) {
        apiCalls.push(dispatch(getPhysiciansAndEkgStackCount(teams[0].id)))
      }

      return Promise.all(apiCalls)
    })
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('getDashboardData', err)
      dispatch(dataFailure())
    })
}

export const handleOnNavClick = (resetFiltersAndSorts = true, handleRouting = false) => (dispatch, getState) => {
  let promises = Promise.resolve()
  if (handleRouting) {
    promises = promises
      .then(() => history.push(ROUTES.DASHBOARD))
  }

  if (resetFiltersAndSorts) {
    promises = promises
      .then(() => dispatch(resetFilters()))
  }

  return promises
}

const DEFAULT_LAST_NUMBER_OF_DAYS = 14
const filters = Object.assign({}, {
  selectedPhysicianId: null,
  selectedStartDate: moment().subtract(DEFAULT_LAST_NUMBER_OF_DAYS, 'day').startOf('day'),
  selectedEndDate: moment().endOf('day'),
})
const initialState = {
  ...filters,
  dataIsFetching: false,
  dataLastUpdated: null,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [RESET_FILTERS]: (state, action) => ({
    ...state, ...filters,
  }),
  [UPDATE_SELECTED_PHYSICIAN_ID]: (state, action) => ({
    ...state, selectedPhysicianId: action.payload,
  }),
  [DATA_REQUEST]: (state, action) => ({
    ...state, dataIsFetching: true,
  }),
  [DATA_SUCCESS]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [DATA_FAILURE]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function dashboardReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/Dashboard/module.js